module.exports = __webpack_public_path__ + "img/img_3.b0684261.png";